import { useState, useEffect, useRef } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function FxTicker() {
  const [rate, setRate] = useState(null);
  const [dir, setDir] = useState(0); // 1 up, -1 down, 0 flat
  const prev = useRef(null);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const d = await fetch('/fxlive').then(r => r.json());
        if (!alive || !d.usd_inr) return;
        const r = Number(d.usd_inr);
        if (prev.current != null) setDir(r > prev.current ? 1 : r < prev.current ? -1 : 0);
        prev.current = r;
        setRate(r);
      } catch { /* ignore */ }
    };
    tick();
    const id = setInterval(tick, 10000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (rate == null) return null;
  const color = dir > 0 ? '#34d399' : dir < 0 ? '#f87171' : 'var(--text-dim)';
  const Icon = dir < 0 ? TrendingDown : TrendingUp;

  return (
    <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full"
      style={{ background: 'var(--surface)', border: '1px solid var(--surface-border)' }}>
      <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-mute)', letterSpacing: '0.04em' }}>USD/INR</span>
      <span className="font-num tabular-nums" style={{ fontSize: '14px', fontWeight: 700, color: 'var(--text)' }}>₹{rate.toFixed(2)}</span>
      <Icon size={13} style={{ color }} strokeWidth={2.5} />
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: color, boxShadow: `0 0 6px ${color}`, animation: 'pulse 2s infinite' }} />
    </div>
  );
}
